import React, { useContext, useEffect, useState } from 'react';

import {
    Grid,
} from '@material-ui/core';

import { PricingForm } from './PricingForm';

import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';
import { UserContext } from '../../../../contexts';

import { RequestStatus, ApplicationRoles } from '../../../../../helpers';

import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        marginTop: 20
    }
}));

export const PricingTab = (props) => {
    const classes = useStyles();

    const { 
        userInfo,
        isUserInRole, 
        isUserInRoles 
    } = useContext(UserContext);

    const {
        state
    } = useContext(CustomerRequestContext);

    const { 
        values,
        isSubmitting
    } = useContext(TabsContext);

    const [disabled, setDisabled] = useState(false);
    useEffect(() => {
        setDisabled(isSubmitting
            || !(
                (state.request.status === RequestStatus.Draft
                    && isUserInRole(ApplicationRoles.AOFOpener))
                ||
                (state.request.status === RequestStatus.Draft
                    && state.request.customerRequestId === 0
                    && isUserInRole(ApplicationRoles.BossApprover))
                ||
                (state.request.status === RequestStatus.ToBeReviewed
                    && state.request.ownerKey === userInfo.externalKey
                    && isUserInRole(ApplicationRoles.AOFOpener))
                ||
                (state.request.status === RequestStatus.AccountReceivableApproval
                    && isUserInRole(ApplicationRoles.AccountReceivable))
            )
        );
    }, [isSubmitting, state.request.status])

    return (
        <div className={classes.root}>
            <Grid container spacing={3}>
                <Grid item xl={12} xs={12} md={12}>
                    <PricingForm disabled={disabled}/>
                </Grid>
            </Grid>
        </div>
    );
}


